module.exports = __webpack_public_path__ + "static/klincic-69ea9197d9b6c733c677792d4e638d22.jpg";